// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"155":"aff7c719","409":"b20ada9e","485":"c49b8e82"}[chunkId] + ".chunk.css";
};